/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of the flight
 * `FLX` - Flex flight
 * `CAT` - Catalog flight
 * 
 * @export
 */
export const FlightType = {
    CAT: 'CAT',
    FLX: 'FLX'
} as const;
export type FlightType = typeof FlightType[keyof typeof FlightType];


export function instanceOfFlightType(value: any): boolean {
    for (const key in FlightType) {
        if (Object.prototype.hasOwnProperty.call(FlightType, key)) {
            if (FlightType[key as keyof typeof FlightType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FlightTypeFromJSON(json: any): FlightType {
    return FlightTypeFromJSONTyped(json, false);
}

export function FlightTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightType {
    return json as FlightType;
}

export function FlightTypeToJSON(value?: FlightType | null): any {
    return value as any;
}

export function FlightTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FlightType {
    return value as FlightType;
}

